import React from 'react';
import FaPrint from 'react-icons/lib/fa/print';
import { useTranslation } from 'react-i18next';

export default function PrintButton(props) {
  const {t} = useTranslation("dyslexia_risk_report")
  return (
    <button className='dyslexiaPrintButton' onClick={props.onClick}>
      <FaPrint size="18" className='dyslexiaPrintButtonIcon' />
      {t("Print Letters")}
    </button>
  );
}